import { Injectable } from '@angular/core';
import { GlobalBatchActivityStore, ProjectBatchActivityStore, UserBatchActivityStore } from './batchActivity.store';
import { GlobalBatchActivityQuery, ProjectBatchActivityQuery, UserBatchActivityQuery } from './batchActivity.query';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { Topics } from '@common/interfaces/topics';
import { IBatchActivity } from '@common/interfaces/batchActivity';
import { GlobalBatchActivityStrategy, ProjectBatchActivityStrategy, UserBatchActivityStrategy } from '../batchActivityStrategies';

@Injectable({
  providedIn: 'root'
})
export class GlobalBatchActivityService extends CrudService<IBatchActivity, GlobalBatchActivityStore, GlobalBatchActivityQuery> {

  constructor(
    public store: GlobalBatchActivityStore,
    public query: GlobalBatchActivityQuery,
    protected updateStrategy: GlobalBatchActivityStrategy,
    protected actionService: ActionService) {
    super(
      Topics.GLOBAL_BATCH_ACTIVITIES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectBatchActivityService extends CrudService<IBatchActivity, ProjectBatchActivityStore, ProjectBatchActivityQuery> {

  constructor(
    public store: ProjectBatchActivityStore,
    public query: ProjectBatchActivityQuery,
    protected updateStrategy: ProjectBatchActivityStrategy,
    protected actionService: ActionService) {
    super(
      Topics.PROJECT_BATCH_ACTIVITIES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserBatchActivityService extends CrudService<IBatchActivity, UserBatchActivityStore, UserBatchActivityQuery> {

  constructor(
    public store: UserBatchActivityStore,
    public query: UserBatchActivityQuery,
    protected updateStrategy: UserBatchActivityStrategy,
    protected actionService: ActionService) {
    super(
      Topics.USER_BATCH_ACTIVITIES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }
}

